import { render, staticRenderFns } from "./Content_analysis.vue?vue&type=template&id=7bb2675b&style=height%3A%20100%25%3B"
import script from "./Content_analysis.vue?vue&type=script&lang=js"
export * from "./Content_analysis.vue?vue&type=script&lang=js"
import style0 from "./Content_analysis.vue?vue&type=style&index=0&id=7bb2675b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports